import "../../css/fonts.css";
import "../../css/container.css";
import "../../css/misc.css";
import "../../css/subpages.css";

import { useIsMobile } from "../../hooks/is.mobile";
import { CenteredImageStrip } from "../../components/image.strip";
import { ImportAll, shuffleArray } from "../../utils/utils";
import { Clickable } from "../../components/clickable.container";
import { useNavigate } from "react-router-dom";
import backIcon from "../../assets/back.png";

const imported = ImportAll(
  require.context("../../assets/3dArt", false, /\.(png|jpe?g|svg)$/)
);
const images = shuffleArray(imported);

export const Art3D: React.FC<any> = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  return (
    <div>
      <div>
        {isMobile ? (
          <Clickable
            backgroundUrl={backIcon}
            onclick={() => {
              navigate("/services");
            }}
            style="back"
          />
        ) : (
          ""
        )}
        <div className={"title-text-font" + " " + "text-align" + " " + "title"}>
          Sculpting Creativity
        </div>
      </div>

      <div
        style={{
          paddingLeft: isMobile ? "10vw" : "4.5vw",
          paddingRight: isMobile ? "10vw" : "4.5vw",
          paddingTop: isMobile ? "6vw" : "2.5vw",
          paddingBottom: isMobile ? "6vw" : "2vw",
          fontSize: isMobile ? "4vw" : "1.5vw",
        }}
      >
        <p>
          This collection showcases the diverse skills and creative journey of
          our lead artist. It features polished 3D renders alongside practice
          pieces and concept art that explore new ideas and techniques.
        </p>
        <p>
          Each image reflects a passion for growth, attention to detail, and a
          commitment to pushing creative boundaries. Whether for finished
          projects or artistic exploration, these works demonstrate the talent
          and dedication behind our studio.
        </p>
      </div>
      <div style={{ paddingTop: "2vw" }}>
        <CenteredImageStrip images={images} />
      </div>

      <div
        className={
          "title-text-font" + " " + "text-align" + " " + "optional-text"
        }
      >
        Looking for something custom? Get in touch, and let’s build something
        great together.
      </div>
    </div>
  );
};
